type RaceTypeFiltersType = {
  type: "SET_RACE_TYPE_FILTERS";
  payload: string[];
};
type RegionFiltersType = {
  type: "SET_REGION_FILTERS";
  payload: string[];
};
type ClearFiltersType = { type: "CLEAR_FILTERS" };

export type RaceTracksFilterActionTypes =
  | RaceTypeFiltersType
  | RegionFiltersType
  | ClearFiltersType;

export const setRaceTypeFilters = (filters: string[]): RaceTypeFiltersType => ({
  type: "SET_RACE_TYPE_FILTERS",
  payload: filters
});

export const setRegionFilters = (filters: string[]): RegionFiltersType => ({
  type: "SET_REGION_FILTERS",
  payload: filters
});

export const clearFilters = (): ClearFiltersType => ({
  type: "CLEAR_FILTERS"
});
